/**
 * Generate a random integet between given range
 */
export const getRandomIntBetween = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}
